import App from "./App.svelte";
import "./styles/global.scss";
const app = new App({
    target: document.body,
    props: {},
});
export default app;
